import PageBuilderBackButton from '@src/components/battle/demo/blocks/PageBuilderBackButton'
import PageBuilderPage from '@src/components/battle/demo/blocks/PageBuilderPage'
import BattleDemoSecNavBar from '@src/components/navigationBar/secondary/BattleDemoSecNavBar'
import { ROUTE } from '@src/constants/route'
import { useSecondaryNavBarContext } from '@src/contexts/share/SecondaryNavBarContext'
import useFetchPageBuilderBreedingGuideJson from '@src/hooks/json/useFetchPageBuilderBreedingGuideJson'
import { useEffect } from 'react'

export const BreedingGuidePage = () => {
  const { data } = useFetchPageBuilderBreedingGuideJson()

  const { setupBar } = useSecondaryNavBarContext()

  useEffect(() => {
    setupBar(<BattleDemoSecNavBar route={ROUTE.BATTLE_DEMO_BEGINNERS_GUIDE} />)

    return () => setupBar(null)
  }, [setupBar])

  if (!data) {
    return null
  }

  return (
    <>
      <PageBuilderPage data={data} />
      <PageBuilderBackButton href={ROUTE.BATTLE_DEMO_BEGINNERS_GUIDE} />
    </>
  )
}

export default BreedingGuidePage
